import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { REQUIRE_AUTH } from '../shared/interceptors/auth-context';

export interface MessagePackageCatalogItem {
  messagePackageCatalogId: string;
  name: string;
  messageQuantity: number | null;
  isCustom: boolean;
  isActive: boolean;
  priceCop: number | null;
  displayOrder: number;
}

export interface MessageCreditsStatus {
  freeQuotaLimit: number;
  freeUsed: number;
  freeRemaining: number;
  packageTotalCredits: number;
  packageUsedCredits: number;
  packageRemainingCredits: number;
  totalRemainingCredits: number;
  cycleStartUtc: string;
  cycleEndUtc: string;
}

export interface CreateMessagePackageCheckoutRequest {
  messagePackageCatalogId: string | null;
  customQuantity: number | null;
}

export interface MessagePackageCheckoutResponse {
  messagePackagePurchaseId: string;
  invoiceReference: string;
  messageQuantity: number;
  amountCop: number;
  currency: string;
  description: string;
  extra1BusinessId: string;
  extra2PurchaseId: string;
  confirmationUrl: string;
  responseUrl: string;
}

@Injectable({ providedIn: 'root' })
export class MessagePackagesService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiUrl;

  getCatalog(): Observable<MessagePackageCatalogItem[]> {
    return this.http.get<MessagePackageCatalogItem[]>(
      `${this.baseUrl}/api/v1/messagepackages/catalog`,
      { context: new HttpContext().set(REQUIRE_AUTH, true) },
    );
  }

  getStatus(): Observable<MessageCreditsStatus> {
    return this.http.get<MessageCreditsStatus>(
      `${this.baseUrl}/api/v1/messagepackages/status`,
      { context: new HttpContext().set(REQUIRE_AUTH, true) },
    );
  }

  createCheckout(
    request: CreateMessagePackageCheckoutRequest,
  ): Observable<MessagePackageCheckoutResponse> {
    return this.http.post<MessagePackageCheckoutResponse>(
      `${this.baseUrl}/api/v1/messagepackages/checkout`,
      request,
      { context: new HttpContext().set(REQUIRE_AUTH, true) },
    );
  }
}
